import {Button, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import {submitVoip} from "../../services/voip/voip";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "عنوان", "نام و نام‌خانوادگی", "رشته و گرایش", "تایم", "تاریخ", "موضوع", "چالش", "عملیات"];

export function AgentReservationGrid({
                                       AgentReservations,
                                       setModalOpen,
                                       setSelectedRow,
                                     }) {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const [voipLog, setVoipLog] = useState(null);

  const voipCall = async (id) => {
    const data = {
      reservation_id: id,
    };
    let result;

    result = await submitVoip(data)

    if (result.status === 200) {
      const {voip_log} = result.data;
      setVoipLog(voip_log && voip_log)
    }
  };

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "عنوان": "title",
    "نام و نام‌خانوادگی": "client_name",
    "رشته و گرایش": "field_title",
    "تایم": "start_time",
    "تاریخ": "date",
    "موضوع": "topic",
    "چالش": "challenge",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "نام و نام‌خانوادگی": true,
    "رشته و گرایش": true,
    "تایم": true,
    "تاریخ": true,
    "موضوع": true,
    "چالش": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {AgentReservations.map(
          ({
             id,
             title,
             client_name,
             client_family,
             field_title,
             branch_title,
             start_time,
             end_time,
             date,
             topic,
             challenge,
             status
           }, index) => {
            const isLast = index === AgentReservations.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {client_name + " " + client_family}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={field_title + " " + branch_title} length={20}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(start_time + " - " + end_time)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(date)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={topic}/>
                </td>

                <td className={classes}>
                  <TableTdContent content={challenge}/>
                </td>

                <td className={classes}>
                  <Button variant="outlined" disabled={!status} onClick={() => {
                    voipCall(id)
                  }}
                  >
                    تماس
                  </Button>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}